import { create } from 'zustand'

interface ModalSearchIdState {
  isOpen: boolean
  searchFrom: string | undefined
  setModalSearchIdState: ({
    isOpen,
    searchFrom
  }: {
    isOpen: boolean
    searchFrom: string | undefined
  }) => void
  reset: () => void
}

const initialState = {
  isOpen: false,
  searchFrom: undefined
}

export const useModalSearchIdStore = create<ModalSearchIdState>()((set) => ({
  ...initialState,
  setModalSearchIdState: ({
    isOpen,
    searchFrom
  }: {
    isOpen: boolean
    searchFrom: string | undefined
  }) => set({ isOpen, searchFrom }),
  reset: () => set({ ...initialState })
}))
